import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import Auth0Notification from '../Auth0Notification';
import Modal from '../Modal';
import ApplianceStatus from '../ApplianceStatus';
import { getDaysBetweenDates, getFromNowDate, MIN_DAYS_TO_SHOW_APPLIANCE_STATUS_WARNING } from '../../utils/dateUtility';

const ApplianceStatusNotification = ({
  applianceUsageRecords,
  applianceUsageDueDate,
  isModalShown,
  showModal,
  hideModal,
  showOutdatedAlert,
  showInfoLink,
  withPipe
}) => {

  //We need to find the most outdated production instance.
  const mostOutdatedProductionApplianceRecord = _(applianceUsageRecords)
    .filter(record => record.last_submitted && record.environment === 'Production')
    .sortBy('last_submitted')
    .value()[0];

  const noProductionValidInstance = mostOutdatedProductionApplianceRecord === undefined;

  const noApplianceUsageRecords = applianceUsageRecords && applianceUsageRecords.length === 0;

  const isOutdated = noApplianceUsageRecords || noProductionValidInstance ||
    (getDaysBetweenDates(mostOutdatedProductionApplianceRecord.last_submitted, applianceUsageDueDate) >= MIN_DAYS_TO_SHOW_APPLIANCE_STATUS_WARNING);


  const productionNotDataReceivedMessage = noProductionValidInstance ?
    'Usage data has not been received from your production Private Instance yet.' :
    `Usage data has not been received from your production Private Instance for
    ${getFromNowDate(mostOutdatedProductionApplianceRecord.last_submitted, applianceUsageDueDate, true)}.`;

  const productionDataReceivedMessage = !noProductionValidInstance &&
    `Usage data received ${getFromNowDate(mostOutdatedProductionApplianceRecord.last_submitted, applianceUsageDueDate)}`;


  if (isOutdated && showOutdatedAlert) {
    return (
      <div>
        <Auth0Notification type="danger">
          {productionNotDataReceivedMessage}{' '}
          {!noApplianceUsageRecords && (
            <button
              style={{ lineHeight: 1, padding: '0' }}
              className="btn-link"
              onClick={showModal}
            >
              View details
            </button>
          )}
        </Auth0Notification>
        <Modal
          title="Private Cloud Status"
          show={isModalShown}
          onHide={hideModal}
        >
          <ApplianceStatus
            records={applianceUsageRecords}
            dueDate={applianceUsageDueDate}
          />
        </Modal>
      </div>
    );
  } else if (!isOutdated && showInfoLink) {
    return (
      <div style={{ display: 'inline-block' }}>
        <span style={{ color: 'rgba(0, 0, 0, 0.57)' }}>
          {withPipe && <span style={{ marginRight: '10px' }}>|</span>}
          {productionDataReceivedMessage}.
          <button
            style={{ lineHeight: 1, padding: '0' }}
            className="btn-link"
            onClick={showModal}
          >
            View details
          </button>
        </span>
        <Modal
          title="Private Cloud Status"
          show={isModalShown}
          onHide={hideModal}
        >
          <ApplianceStatus
            records={applianceUsageRecords}
            dueDate={applianceUsageDueDate}
          />
        </Modal>
      </div>
    );
  }

  return null;
};


ApplianceStatusNotification.propTypes = {
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  applianceUsageRecords: PropTypes.array,
  applianceUsageDueDate: PropTypes.string,
  isModalShown: PropTypes.bool,
  showOutdatedAlert: PropTypes.bool,
  showInfoLink: PropTypes.bool,
  withPipe: PropTypes.bool
};

ApplianceStatusNotification.defaultProps = {
  applianceUsageRecords: [],
  applianceUsageDueDate: moment().toISOString(),
  isModalShown: false,
  showOutdatedAlert: false,
  showInfoLink: false,
  withPipe: false
};


export default ApplianceStatusNotification;
